export const dashboardPath = {
  projects: '/',
  trash: '/trash',
  team: '/team',
  ai: '/ai',
  logs: '/ai-logs',
  prompts: '/prompts',
} as const

export type DashboardView = keyof typeof dashboardPath

export function dashboardViewFromSegment(segment: string | undefined): DashboardView | null {
  if (segment === undefined) return 'projects'
  if (segment === 'ai-logs') return 'logs'
  return segment === 'trash' || segment === 'team' || segment === 'ai' || segment === 'prompts' ? segment : null
}

export function projectPath(projectId: string): string {
  return `/projects/${encodeURIComponent(projectId)}`
}

export function projectAiWorkbenchPath(projectId: string, nodeId?: string): string {
  const suffix = nodeId ? `/${encodeURIComponent(nodeId)}` : ''
  return `${projectPath(projectId)}/ai-workbench${suffix}`
}

export function projectCodeWorkbenchPath(projectId: string, nodeId?: string): string {
  const suffix = nodeId ? `/${encodeURIComponent(nodeId)}` : ''
  return `${projectPath(projectId)}/code-workbench${suffix}`
}
